import { render } from "./cpt-rect-num.vue?vue&type=template&id=e1fe646e"
import script from "./cpt-rect-num.vue?vue&type=script&lang=js"
export * from "./cpt-rect-num.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__